import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Плющ';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p className="sub">Hedera</p>
                    <div className="two-col-cell">
                        <img src={require('./../img/topics/Hedera/hedera.jpg')}/>
                    </div>
                    <div className="two-col-cell">
                        <p>Род вечнозелёных лиан семейства аралиевых. 15 видов, распространены в Евразии. В
                            Беларуси отмечен плющ обыкновенный, редкий реликтовый вид, занесён в Красную книгу Беларуси.
                            Растёт в тенистых лиственных лесах. В естественных условиях Беларуси не цветёт. Зимует
                            только
                            под снегом. Выращивают как декоративное и комнатное растение. Стебель длиной 3 - 5 (иногда
                            до 20
                            и более) м, цепляется за деревья многочисленными воздушными корнями-присосками. Листья
                            цельные
                            или 3 - 5-лопастные, кожистые, сверху блестящие. Цветки зеленоватые, в шаровидных зонтиках,
                            собранных в кистевидные или метельчатые соцветия. Плод ягодовидный.</p>
                    </div>
                </div>
            </div>
        </>
    );
}